import Cookies from 'js-cookie';
import { newElement } from '../utils/drawing';

/**
 * Footer controls.
 */
export default function footerSection() {

  const hubspotNewsletterForm = document.getElementById('hubspotNewsletterForm');
  if (!hubspotNewsletterForm) return;

  // Send form function
  async function sendForm() {

    // Get form settings
    const settings = JSON.parse(hubspotNewsletterForm.dataset.hubspotData);
    if (!settings) return;

    // HS specific form body (from https://legacydocs.hubspot.com/docs/methods/forms/submit_form)
    let context = {
      "pageUri": settings.pageUri,
      "pageName": settings.pageName,
    }
    if (Cookies.get('hubspotutk')) context["hutk"] = Cookies.get('hubspotutk'); // If tracking exists add it
    let body = {
      "submittedAt": Date.now(),
      "fields": [{
        "objectTypeId": "0-1",
        "name": "email",
        "value": hubspotNewsletterForm.querySelector('input[type="email"]').value
      }],
      "context": context,
      "legalConsentOptions": {
        "consent": { // Include this object when GDPR options are enabled
          "consentToProcess": true,
          "text": "I agree to receive other communications from Tesserent.",
        }
      }
    };

    // Post form
    const url = `https://api.hsforms.com/submissions/v3/integration/submit/${settings.portalId}/${settings.formGuid}`;
    await require('axios').post(
      url,
      body,
      {
        'Content-Type': 'application/json'
      }
    )
    .then(response => {
      if (response.status === 200) {
        hubspotNewsletterForm.innerHTML = `<div class="text">
          <p class="+v-margin-none">
            ${response.data.inlineMessage ? response.data.inlineMessage : 'Thanks!'}
          </p>
        </div>`;
      } else {
        console.error(error);
      }
    })
    .catch(error => {
      console.error(error);
    })
    .then(() => {
      hubspotNewsletterForm.classList.remove('-posting');
    });
  }

  // Submit event
  hubspotNewsletterForm.addEventListener('submit', event => {

    event.preventDefault();

    // Post it...
    hubspotNewsletterForm.classList.add('-posting');
    sendForm();
  });
}


// WEBPACK FOOTER //
// ./source/scripts/sections/footer.js